"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Bucket_1 = __importDefault(require("./Bucket"));
const guards_1 = require("./guards");
const factory_1 = __importDefault(require("./factory"));
const utils_1 = require("./utils");
const NewArray = (subtype, length) => {
    if (subtype === 'uint8') {
        return new Uint8Array(length);
    }
    if (subtype === 'uint16') {
        return new Uint16Array(length);
    }
    if (subtype === 'uint32') {
        return new Uint32Array(length);
    }
    if (subtype === 'float64') {
        return new Float64Array(length);
    }
    return new Array(length);
};
const decode = (args) => {
    var _a, _b;
    const { bytes, instance, position } = args;
    const key = (_a = args.key, (_a !== null && _a !== void 0 ? _a : ''));
    const type = (_b = args.type, (_b !== null && _b !== void 0 ? _b : typeof instance));
    const bucket = new Bucket_1.default(bytes, position);
    if (guards_1.isDecoder(instance)) {
        return instance.decode(bytes, position);
    }
    switch (type) {
        case 'boolean': {
            Reflect.set(instance, key, bucket.readBoolean());
            break;
        }
        case 'int8': {
            Reflect.set(instance, key, bucket.readInt8());
            break;
        }
        case 'uint8': {
            Reflect.set(instance, key, bucket.readUint8());
            break;
        }
        case 'int16': {
            Reflect.set(instance, key, bucket.readInt16());
            break;
        }
        case 'uint16': {
            Reflect.set(instance, key, bucket.readUint16());
            break;
        }
        case 'int32': {
            Reflect.set(instance, key, bucket.readInt32());
            break;
        }
        case 'uint32': {
            Reflect.set(instance, key, bucket.readUint32());
            break;
        }
        case 'int64': {
            Reflect.set(instance, key, bucket.readInt64());
            break;
        }
        case 'uint64': {
            Reflect.set(instance, key, bucket.readUint64());
            break;
        }
        case 'float32': {
            Reflect.set(instance, key, bucket.readFloat32());
            break;
        }
        case 'float64': {
            Reflect.set(instance, key, bucket.readFloat64());
            break;
        }
        case 'string': {
            Reflect.set(instance, key, bucket.readString());
            break;
        }
        case 'Date': {
            Reflect.set(instance, key, bucket.readDate());
            break;
        }
        case 'ByteString': {
            Reflect.set(instance, key, bucket.readByteString());
            break;
        }
        case 'Array': {
            const n = bucket.readInt32();
            if (n === -1) {
                return bucket.position;
            }
            // create array by name with length
            const subtype = Reflect.getMetadata('design:subtype', instance, key);
            const a = NewArray(subtype, n);
            for (let i = 0; i < n; i++) {
                // create new instance of given type and add it to the array
                a[i] = factory_1.default(subtype);
                // decode instance
                bucket.position = decode({
                    bytes: bucket.bytes,
                    instance: utils_1.isPrimitiveType(subtype) ? a : a[i],
                    key: i,
                    type: subtype,
                    position: bucket.position
                });
            }
            Reflect.set(instance, key, a);
            break;
        }
        default:
            for (const name of Object.getOwnPropertyNames(instance)) {
                if (guards_1.isNotNullObject(instance) && guards_1.keyInObject(instance, name)) {
                    const type = Reflect.getMetadata('design:type', instance, name);
                    bucket.position = decode({
                        bytes: bytes,
                        instance: type === 'object' ? instance[name] : instance,
                        key: name,
                        type,
                        position: bucket.position
                    });
                }
            }
    }
    return bucket.position;
};
exports.default = decode;
